module.exports = __webpack_public_path__ + "0d2e093cdd3f92fbba68571176a886fb.png";